import React from 'react';
import I18n from 'i18n-js';
import { trackPageView } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface ExternalProps {
  isBrandPage: Boolean;
  searchParams: String;
  trackingProps: Object;
}

function trackSearchFeedback(feedback, marketplaceProps) {
  const trackingData = {
    interactionType: 'Search Feedback',
    displayStyle: feedback,
  };

  trackPageView({
    ...trackingData,
    ...marketplaceProps,
  });
}

export default function SearchFeedback(props: ExternalProps) {
  const [hasSubmittedFeedback, setHasSubmittedFeedback] = React.useState(false);

  if (props.isBrandPage) { return null; }
  if (props.searchParams === '') { return null; }

  if (hasSubmittedFeedback) {
    return (
      <div className="d-flex fx-align-center fx-justify-center scaling-mtb-3">
        <span className="mr-space pt-space pb-space">
          {I18n.t('discovery.marketplace.searchFeedback.thanks')}
        </span>
        <span className="fa fa-check" />
      </div>
    );
  }

  return (
    <div className="d-flex fx-align-center fx-justify-center scaling-mtb-3">
      <span className="mr-1 pt-space pb-space">
        {I18n.t('discovery.marketplace.searchFeedback.question')}
      </span>
      <button
        className="button button--mini mr-space"
        onClick={() => {
          trackSearchFeedback('Yes', props.trackingProps);
          setHasSubmittedFeedback(!hasSubmittedFeedback);
        }}
        type="button"
        aria-label="Yes"
      >
        <span className="fa fa-thumbs-up" />
      </button>
      <button
        className="button button--mini"
        onClick={() => {
          trackSearchFeedback('No', props.trackingProps);
          setHasSubmittedFeedback(!hasSubmittedFeedback);
        }}
        type="button"
        aria-label="No"
      >
        <span className="fa fa-thumbs-down" />
      </button>
    </div>
  );
}
